export const AppRoutes = {
  login: '/login',
  dashboard: '/dashboard'
};